import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import useStores from "stores";
import { useHistory } from "react-router-dom";
import RichText from 'components/RichText';

import "./index.scss";

const Solution = observer(({detail}) => {
  // const { loginStore } = useStores();
  let html = `
    <style>
      body, p {
        margin: 0;
      }
    </style>
    ${detail.bigContent || ''}
  `;
  const history = useHistory();
  useEffect(() => {}, []);

  return (
    <div className="componets_details_solution">
      <div className="main_content">
        <RichText html={html} />
      </div>
      {detail?.bigContent?.length > 0 && <div className="content_footer">
        <div className="component-box component-on">
          <h4 className="c_title">接入组件</h4>
          <div className="img-box">
            <img src="https://img10.360buyimg.com/imagetools/jfs/t1/189805/20/25118/106198/6284a034E97ee4e16/7ae5db73b9f0721d.png" />
          </div>
        </div>
      </div>}
    </div>
  );
});

export default Solution;
